export default __webpack_public_path__ + "static/livros-c05e583ba76da3543a029bcd3d118b99.png";